'use client';
import { getRelativeTimeString } from "../../../Utils/datetime";
import '../JobBoard.css';

export default function JobCard({ company, title, description, location, timePosted, logo, applylink }) {

  const stripHTML = (htmlString) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    return doc.body.textContent || "";
  };

  const plainDescription = description ? stripHTML(description) : "";

  const handleButtonClick = () => {
    if (applylink && applylink !== "null") {
      window.open(applylink, "_blank");
    } else {
      const query = encodeURIComponent(`${title} ${company} ${location} job`);
      window.open(`https://www.google.com/search?q=${query}`, "_blank");
    }
  };

  const hasApplyLink = applylink && applylink !== "null";

  return (
    <div className="job-card">
      <div className="Job">
        <img className="company-logo" src={logo || "/images/Job/image.png"} alt={`${company} logo`} />
        <div className="job-info">
          <h4 className="company_name">{company}</h4>
          <h3 className="job-title">{title}</h3>

          {plainDescription && (
            <p className="job-description">{plainDescription}</p>
          )}
          <div className="job-metaData" id="job-metaData_flex-clmn">
            <div className="job-meta">
              <span>Posted {getRelativeTimeString(timePosted)}</span>
            </div>
            <span className="location">
              <span className="locationIcon">
                <img src='/images/Job/location_on1.svg' alt="Location Icon" />
              </span>
              {location}
            </span>
          </div>
        </div>
      </div>
      <div className="Job-metaData">
        <div className="job-metaData" id="job-metaData_flex-row">
          <div className="job-meta">
            <span>Posted {getRelativeTimeString(timePosted)}</span>
          </div>
          {
            location && (
              <span className="location">
                <span className="locationIcon">
                  <img src='/images/Job/location_on1.svg' alt="Location Icon" />
                </span>
                {location}
              </span>
            )
          }
        </div>
        <button
          className={`apply-btn ${!hasApplyLink ? "google-style-btn" : ""}`}
          onClick={handleButtonClick}
        >
          <span className="ApplyNowbtn">
            {hasApplyLink ? (
              <>
                Apply Now <img src='/images/Job/open_in_new.svg' alt="Open in new tab" />
              </>
            ) : (
              <>Search on Google</>
            )}
          </span>
        </button>
      </div>
    </div>
  );
}
